// src/components/ai/ChatSidebar.js
import React, { useState, useEffect } from 'react';
import { BsX, BsPlus } from 'react-icons/bs';
import { fetchSessionsWithToken } from '../../api/ai';
import { useAuthContext } from '../../context/AuthContext';

export default function ChatSidebar({ isOpen, onClose, onSelectSession, currentSessionId, onNewChat }) {
  const [sessions, setSessions] = useState([]);
  const [loading, setLoading] = useState(false);
  const { getAuthTokens } = useAuthContext();

  useEffect(() => {
    if (!isOpen) return;
    setLoading(true);
    
    const token = getAuthTokens();
    if (!token) {
      setLoading(false);
      return;
    }

    fetchSessionsWithToken(token)
      .then(data => setSessions(Array.isArray(data) ? data : []))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [isOpen, getAuthTokens]);

  const handleNew = () => {
    onNewChat();
    onClose();
  };

  return (
    <>
      {isOpen && <div className="fixed inset-0 bg-black/30 z-50" onClick={onClose} />}
      <div className={`fixed top-0 right-0 h-full w-80 max-w-[85vw] bg-white/90 backdrop-blur-xl shadow-2xl z-50 transform transition-transform duration-300 ${isOpen ? 'translate-x-0' : 'translate-x-full'}`}>
        <div className="flex items-center justify-between p-4 border-b">
          <h3 className="font-bold text-lg">تاریخچه گفتگوها</h3>
          <button onClick={onClose}><BsX size={24} /></button>
        </div>
        <div className="p-4">
          <button onClick={handleNew} className="w-full flex items-center justify-center gap-2 mb-4 py-2 bg-blue-600 text-white rounded-xl">
            <BsPlus size={20} /> گفتگوی جدید
          </button>
          {loading ? (
            <p className="text-center text-sm text-gray-500">در حال بارگذاری...</p>
          ) : sessions.length === 0 ? (
            <p className="text-center text-sm text-gray-500">هنوز گفتگویی ندارید.</p>
          ) : (
            <ul className="space-y-2">
              {sessions.map(s => (
                <li key={s.session_id} onClick={() => { onSelectSession(s.session_id); onClose(); }}
                  className={`p-3 rounded-lg cursor-pointer transition ${s.session_id === currentSessionId ? 'bg-blue-100 border border-blue-300' : 'hover:bg-gray-100'}`}>
                  <p className="text-sm font-medium truncate">{s.title}</p>
                  <div className="flex justify-between text-xs text-gray-500 mt-1">
                    <span>{s.question_count} پرسش</span>
                    {s.is_full && <span className="text-red-500">● پر شده</span>}
                  </div>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </>
  );
}